import { Condition, Query } from '@deckplan.io/common/filters';
import { CommonColumns } from './common-columns';
import { FilterUtils } from '../../common/filter/utils';
import { Pagination, QueryGroup } from '@deckplan.io/common';
import { AlertLevel } from '../../common/alerts/alerts.service';

export class Utils {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static TranslateOwnedFieldFilters(query: Query) {

        // If we don't have a query, don't bother
        if (query === null || query === undefined) {
            return;
        }

        // We need to change our filter from 'True' to 'NULL', since the user doesn't know that inventoryId is not just a boolean,
        // but our backend won't understand us trying to filter an ID by a boolean value
        const ownedColumn = CommonColumns.find(column => column.field.title === 'Owned' && column.field.field === 'inventoryId').field;
        const ownedToFind = {operation: '=', dataField: ownedColumn, value: 'True'} as Condition;
        const destinationOwned = {operation: '!=', dataField: ownedColumn, value: 'NULL'} as Condition;
        FilterUtils.translateOperation(query, ownedToFind, destinationOwned);

        // Repeat the above operation for the False case
        ownedToFind.value = 'False';
        destinationOwned.operation = '=';
        FilterUtils.translateOperation(query, ownedToFind, destinationOwned);
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static PageOrDefault(pagination: Pagination) {
        const defaultSort = {active: 'name', direction: 'asc' as any};
        const defaultPage = {pageSize: 10, pageIndex: 0};
        if (!pagination) {
            return {page: defaultPage, sort: defaultSort};
        }
        const {active, direction} = pagination.sort ? pagination.sort : defaultSort;
        const {pageIndex, pageSize} = pagination.page ? pagination.page : defaultPage;
        return {page: {pageIndex, pageSize}, sort: {active, direction}};
    }

    public static handleExport(exportString: string, clipboard, alertsService, exportName: string) {
        if (exportName.length > 0) {
            const a = document.createElement('a');
            const file = new Blob([exportString], {type: 'text/plain'});

            a.href = URL.createObjectURL(file);
            a.download = `${exportName}.txt`;
            a.click();

            URL.revokeObjectURL(a.href);
            alertsService.alert(`Export saved to ${exportName}.txt!`);
        } else {
            clipboard.copy(exportString);
            alertsService.alert('Export copied to clipboard!', AlertLevel.InfoSuccess);
        }
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static AddInventoryCardFields(query: Query) {
        if (query && query.hasOwnProperty('dataField') && (query as any).objectType === 'card') {
            const conditionOne = {...query};
            const conditionTwo = {...query};
            (conditionTwo as any).objectType = 'inventoryCardCard';
            query = {
                operator: 'or',
                operands: [
                    conditionOne,
                    conditionTwo
                ]
            };
        } else if (query && query.hasOwnProperty('operands')) {
            const newOperands = [];
            for (const operand of (query as QueryGroup).operands) {
                newOperands.push(this.AddInventoryCardFields(operand));
            }
            (query as QueryGroup).operands = newOperands;
        }

        return query;
    }
}
